import { computed } from 'vue';
import { IImport } from '@/models/imports.interface';
import { Routes } from '@/models/router/router.interface';
import store from '@/store';

export default class ErrorDetailsCode {

	public selectedImport = computed((): IImport | null => {
		return store.getters.selectedImport();
	});

	public navigateToOverviewPage(): void {
		store.mutations.setCurrentRoute(Routes.OVERVIEW);
	}
}
